import(/* webpackMode: "eager" */ "/workspace/frameworkassure/src/app/(auth)/register/error.tsx");
